
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ResultDesactiverUtilisateursModel } from 'src/models/pilotage/resultDesactiverUtilisateursModel';

@Component({
    selector: 'app-result-desactiver-dialog',
    templateUrl: './result-desactiver-dialog.component.html',
    styleUrls: ['./result-desactiver-dialog.component.scss'],
    imports: [
    MatDialogModule,
    TranslateModule
]
})
export class ResultDesactiverDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ResultDesactiverDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResultDesactiverUtilisateursModel
  ) { }

  onClose(): void {
    this.dialogRef.close();
  }
}
